import { Components } from '@mui/material';

const typography: Components = {
  MuiTypography: {
    styleOverrides: {
    }
  }
}

export default typography;